export default __webpack_public_path__ + "static/media/Banner_Catsul_trajeto_2400x1800.4f515086.jpg";